module.exports = __webpack_public_path__ + "static/media/development.orange.gray.r.98260300.png";